export class GetFilters {
  static readonly type = '[Search/Filters] - Get filters';
}

export class UpdateFilterSelection {
  static readonly type = '[Search/Filters] - Update filter selection';

  constructor(
    public filterGroup: string,
    public filterItem: string
  ) {}
}

export class CancelFilters {
  static readonly type = '[Search/Filters] - Cancel filters';
}

export class RemoveAllFilters {
  static readonly type = '[Search/Filters] - Remove all filters';
}

export class ApplyFilters {
  static readonly type = '[Search/Filters] - Apply filters';
}

export class ResetStore {
  static readonly type = '[Search/Filters] - Reset store';
}